var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-y-2"},[_c('div',{staticClass:"flex items-baseline justify-end gap-2 text-right text-sm"},[_c('span',{staticClass:"text-lg font-semibold text-slate-900"},[_vm._v(_vm._s(_vm.value))]),_c('span',{staticClass:"text-sm font-medium text-slate-500"},[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"progress-track"},[_c('div',{staticClass:"progress-segment progress-segment--primary",style:({
      width: _vm.primaryWidth,
      backgroundColor: _vm.primaryColor
    })}),(_vm.secondaryPercent > 0)?_c('div',{staticClass:"progress-segment progress-segment--secondary",style:({
      width: _vm.secondaryWidth,
      backgroundColor: _vm.secondaryColor
    })}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }